import React, {Fragment} from "react"
import CommonCounter from "./CommonCounter"


const counterContent =[
    {
        num:"125",
        desc:"Hemos Desarrollado Más de 125 Software",
    },
    {
        num:"64",
        desc:"Clientes Globales que Confían en Nosotros",
    },
    {
        num:"122",
        desc:"Clientes Reseñan Nuestro Software",
    },
]

const CounterTwo = () => {
    return (
        <Fragment>
            <ul className="list-none count-list">
                {counterContent.map((val,i)=>(
                    <li key={i}>
                        <div className="counter-style-two boder-style d-xxl-flex align-items-center mb-30">
                            <h3><span className="counter"><CommonCounter value={val.num} /></span>+</h3>   
                            <p className="text-white">{val.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </Fragment>
    )
}

export default CounterTwo